import { render, staticRenderFns } from "./FeaturesBlock.vue?vue&type=template&id=914a388e&scoped=true"
import script from "./FeaturesBlock.vue?vue&type=script&lang=js"
export * from "./FeaturesBlock.vue?vue&type=script&lang=js"
import style0 from "./FeaturesBlock.vue?vue&type=style&index=0&id=914a388e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "914a388e",
  null
  
)

export default component.exports